var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormIncomplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.3V3.42701C9 3.25744 9.19777 3.16481 9.32804 3.27336L11.5756 5.14636C11.7193 5.26611 11.6346 5.5 11.4476 5.5H9.2C9.08954 5.5 9 5.41046 9 5.3Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2998 3C8.41026 3 8.5 3.08974 8.5 3.2002V5.7998C8.5 5.91026 8.58974 6 8.7002 6H11.7998C11.9103 6 12 6.08974 12 6.2002V12.5C12 12.7761 11.7761 13 11.5 13H4.5C4.22386 13 4 12.7761 4 12.5V3.5C4 3.22386 4.22386 3 4.5 3H8.2998ZM9.8584 7.7041C9.6358 7.4815 9.27436 7.4815 9.05176 7.7041L8.03125 8.72461L7.01074 7.7041C6.78814 7.4815 6.4267 7.4815 6.2041 7.7041C5.9815 7.9267 5.9815 8.28814 6.2041 8.51074L7.22461 9.53125L6.2041 10.5518C5.9815 10.7744 5.9815 11.1358 6.2041 11.3584C6.4267 11.581 6.78814 11.581 7.01074 11.3584L8.03125 10.3379L9.05176 11.3584C9.27436 11.581 9.6358 11.581 9.8584 11.3584C10.081 11.1358 10.081 10.7744 9.8584 10.5518L8.83789 9.53125L9.8584 8.51074C10.081 8.28814 10.081 7.9267 9.8584 7.7041Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormIncomplete);
export default __webpack_public_path__ + "static/media/Form_incomplete.a612142b471dc654f91899912fbf71bc.svg";
export { ForwardRef as ReactComponent };